import { useLocation } from 'react-router'
import DisableMFA from '../../pages/DisableMFA'
import { withCenteredBaseWithMenu } from '../../components/Base'
import { useSettings } from '../../hooks/useSettings'
import { useInitialization } from '../../contexts/Initialization'
import { RECOVERY_OTP } from '../../constants/mfa'
import { getInitialSettings } from '../../utils/getInitialSettings'

function DisableMFAWrapper() {
  const { user, siteKey } = useInitialization() || {}
  const location = useLocation()
  const mfaToRevoke = location.state?.mfaToRevoke ?? RECOVERY_OTP
  const {
    enabledMFAMechanisms,
    isMFARevokeInProgress,
    isSuccessfullyRevoked,
    revokeMFAErrorCode,
    revokeMechanism,
    revokeAllMechanisms,
  } = useSettings(getInitialSettings(user))

  const isLastMFAMechanism =
    enabledMFAMechanisms.filter((m) => m !== RECOVERY_OTP).length === 1

  return (
    <DisableMFA
      siteKey={siteKey || ''}
      isLastMFAMechanism={isLastMFAMechanism}
      mfaToRevoke={mfaToRevoke}
      isMFARevokeInProgress={isMFARevokeInProgress}
      isSuccessfullyRevoked={isSuccessfullyRevoked}
      revokeMFAErrorCode={revokeMFAErrorCode}
      onRevokeAllMFAMechanisms={revokeAllMechanisms}
      onRevokeMFAMechanism={revokeMechanism}
      onExecuteRecaptcha={() => {}}
    />
  )
}

export default withCenteredBaseWithMenu(DisableMFAWrapper)
